import React from "react";

function VideoForm() {
  return (
    <div className="flex items-center justify-center bg-darkBlue py-24">
      <div className="flex items-center justify-center flex-col px-4 sm:px-0">
        <h2 className="text-white font-secondary text-3xl lg:text-4xl font-bold text-center mb-7">
          Take the next step.
        </h2>
        <p className="text-darkMist font-opensans mb-7 text-center">
          See what it's like to truly engage your audience. Translate your
          videos
        </p>
        <div className="flex flex-wrap sm:flex-nowrap items-center justify-center">
          <input
            type="text"
            className="rounded mr-0 sm:mr-4 pl-4 mb-6 sm:mb-0 h-[51px]"
            placeholder="Enter email address here"
          />
          <button className="text-white font-bold bg-orange py-3 px-4 w-32">
            SUBMIT
          </button>
        </div>
      </div>
    </div>
  );
}

export default VideoForm;
